import React, { useState } from 'react';
import { HiOutlinePlus, HiOutlineTag } from 'react-icons/hi2';
import { FaFileExcel } from 'react-icons/fa';
import CustomDatePicker from '../../../../../../components/common/CustomDatePicker/CustomDatePicker';
import CheckboxMultiSelect from '../../../../../../components/common/CheckboxMultiSelect/CheckboxMultiSelect';
import CategoryManager from './components/CategoryManager/CategoryManager';
import { ExpenseCategoryType } from '../../types';
import './FilterBar.scss';

interface FilterOption {
  value: string | number;
  label: string;
}

interface FilterBarProps {
  startDate: string;
  endDate: string;
  onStartDateChange: (date: string) => void;
  onEndDateChange: (date: string) => void;
  providerFilter: FilterOption[];
  onProviderFilterChange: (providers: FilterOption[]) => void;
  onCreatePurchase: () => void;
  onExportToExcel?: () => void;
  exportDisabled?: boolean;
  totalPurchases?: number;
  providerOptions: FilterOption[];
  searchComponent?: React.ReactNode;
  categories: ExpenseCategoryType[];
  onCategoriesChanged: () => void;
}

const FilterBar: React.FC<FilterBarProps> = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  providerFilter,
  onProviderFilterChange,
  onCreatePurchase,
  onExportToExcel,
  exportDisabled = false,
  totalPurchases = 0,
  providerOptions,
  searchComponent,
  categories,
  onCategoriesChanged,
}) => {
  const [showCategoryManager, setShowCategoryManager] = useState(false);

  return (
    <div className="mp-toolbar compras-toolbar flex flex-wrap items-center gap-3">
      {/* Search */}
      {searchComponent && (
        <div className="compras-search-wrapper">
          {searchComponent}
        </div>
      )}

      {/* Date pickers */}
      <div className="compras-date-filters">
        <CustomDatePicker value={startDate} onChange={onStartDateChange} placeholder="Desde" />
        <CustomDatePicker value={endDate} onChange={onEndDateChange} placeholder="Hasta" />
      </div>

      {/* Provider filter */}
      <div className="compras-provider-filter">
        <CheckboxMultiSelect
          options={providerOptions}
          value={providerFilter}
          onChange={onProviderFilterChange}
          placeholder="Proveedor"
        />
      </div>

      {/* Action buttons - right aligned */}
      <div className="flex items-center gap-2 ml-auto">
        <button
          className="mp-btn-secondary"
          onClick={() => setShowCategoryManager(true)}
          title="Gestionar categorías"
        >
          <HiOutlineTag size={15} /> Categorías
        </button>
        {onExportToExcel && (
          <button
            className="mp-btn-export"
            onClick={onExportToExcel}
            disabled={exportDisabled || totalPurchases === 0}
            title="Exportar a Excel"
          >
            <FaFileExcel />
            <span>Exportar</span>
          </button>
        )}
        <button className="mp-btn-primary" onClick={onCreatePurchase}>
          <HiOutlinePlus size={15} /> Nueva Compra
        </button>
      </div>

      <CategoryManager
        show={showCategoryManager}
        setShow={setShowCategoryManager}
        categories={categories}
        onChanged={onCategoriesChanged}
      />
    </div>
  );
};

export default FilterBar;
